module.exports = __webpack_public_path__ + "img/ggzuhao.f576f209.png";